<template>
  <div class="payouts-registry-main">
    <loader
      class="payouts-registry-main__loader"
      v-if="isRegistryProcessing || isRegistryPositionDeleting"
    ></loader>
    <transactions-page-controls
      :has-filter="false"
      :stats="registryStats"
      :export-options="[{ id: 'xlsx', name: 'export-action.xlsx' }]"
      @refresh="handleRefresh"
      @export="handleExport"
      :is-show-statistic-block-by-default="true"
    >
      <template #statisticDetailed>
        <div class="payouts-registry-main__stats">
          <div class="payouts-registry-main__stats-details">
            <div class="payouts-registry-main__stats-details-item">
              <div class="payouts-registry-main__stats-details-item-title">
                {{ $t('payouts.by-registry.main.stats.details.id') }}
              </div>
              <div class="payouts-registry-main__stats-details-item-value">
                {{ payoutsRegistry.id }}
              </div>
            </div>
            <div class="payouts-registry-main__stats-details-item">
              <div class="payouts-registry-main__stats-details-item-title">
                {{ $t('payouts.by-registry.main.stats.details.count') }}
              </div>
              <div class="payouts-registry-main__stats-details-item-value">
                {{ registryStats.allStats.count }}
              </div>
            </div>
            <div class="payouts-registry-main__stats-details-item">
              <div class="payouts-registry-main__stats-details-item-title">
                {{ $t('payouts.by-registry.main.stats.details.sum') }}
              </div>
              <div class="payouts-registry-main__stats-details-item-value">
                {{ registryStats.allStats.sum }}
              </div>
            </div>
            <div class="payouts-registry-main__stats-details-item">
              <div class="payouts-registry-main__stats-details-item-title">
                {{ $t('payouts.by-registry.main.stats.details.commission') }}
              </div>
              <div class="payouts-registry-main__stats-details-item-value">
                {{ registryCommission }}
              </div>
            </div>
          </div>
          <div class="payouts-registry-main__stats-progress">
            <div
              class="payouts-registry-main__stats-progress-item payouts-registry-main__stats-progress-item--completed"
            >
              <div class="payouts-registry-main__stats-progress-item-bar">
                <div class="payouts-registry-main__stats-progress-item-title">
                  <div
                    class="payouts-registry-main__stats-progress-item-title-text"
                  >
                    {{
                      $t('payouts.by-registry.main.stats.progress.completed')
                    }}
                  </div>
                  <div
                    class="payouts-registry-main__stats-progress-item-title-value"
                  >
                    {{ registryProgressStats.completed.count }}
                    / {{ registryStats.allStats.count }}
                  </div>
                </div>
                <div class="payouts-registry-main__stats-progress-item-row">
                  <div
                    class="payouts-registry-main__stats-progress-item-row-filled"
                    :style="{
                      width: `${registryProgressStats.completed.percents}%`,
                    }"
                  >
                    <div
                      class="payouts-registry-main__stats-progress-item-row-percents"
                      :class="{
                        left: registryProgressStats.completed.percents < 50,
                        right: registryProgressStats.completed.percents >= 50,
                      }"
                    >
                      {{ registryProgressStats.completed.percents }}%
                    </div>
                  </div>
                </div>
              </div>
              <div class="payouts-registry-main__stats-progress-item-amount">
                {{ registryProgressStats.completed.sum }}
              </div>
            </div>
            <div
              class="payouts-registry-main__stats-progress-item payouts-registry-main__stats-progress-item--processing"
            >
              <div class="payouts-registry-main__stats-progress-item-bar">
                <div class="payouts-registry-main__stats-progress-item-title">
                  <div
                    class="payouts-registry-main__stats-progress-item-title-text"
                  >
                    {{
                      $t('payouts.by-registry.main.stats.progress.processing')
                    }}
                  </div>
                  <div
                    class="payouts-registry-main__stats-progress-item-title-value"
                  >
                    {{ registryProgressStats.processing.count }}
                    / {{ registryStats.allStats.count }}
                  </div>
                </div>
                <div class="payouts-registry-main__stats-progress-item-row">
                  <div
                    class="payouts-registry-main__stats-progress-item-row-filled"
                    :style="{
                      width: `${registryProgressStats.processing.percents}%`,
                    }"
                  >
                    <div
                      class="payouts-registry-main__stats-progress-item-row-percents"
                      :class="{
                        left: registryProgressStats.processing.percents < 50,
                        right: registryProgressStats.processing.percents >= 50,
                      }"
                    >
                      {{ registryProgressStats.processing.percents }}%
                    </div>
                  </div>
                </div>
              </div>
              <div class="payouts-registry-main__stats-progress-item-amount">
                {{ registryProgressStats.processing.sum }}
              </div>
            </div>
            <div
              class="payouts-registry-main__stats-progress-item payouts-registry-main__stats-progress-item--error"
            >
              <div class="payouts-registry-main__stats-progress-item-bar">
                <div class="payouts-registry-main__stats-progress-item-title">
                  <div
                    class="payouts-registry-main__stats-progress-item-title-text"
                  >
                    {{ $t('payouts.by-registry.main.stats.progress.error') }}
                  </div>
                  <div
                    class="payouts-registry-main__stats-progress-item-title-value"
                  >
                    {{ registryProgressStats.error.count }}
                    / {{ registryStats.allStats.count }}
                  </div>
                </div>
                <div class="payouts-registry-main__stats-progress-item-row">
                  <div
                    class="payouts-registry-main__stats-progress-item-row-filled"
                    :style="{
                      width: `${registryProgressStats.error.percents}%`,
                    }"
                  >
                    <div
                      class="payouts-registry-main__stats-progress-item-row-percents"
                      :class="{
                        left: registryProgressStats.error.percents < 50,
                        right: registryProgressStats.error.percents >= 50,
                      }"
                    >
                      {{ registryProgressStats.error.percents }}%
                    </div>
                  </div>
                </div>
              </div>
              <div class="payouts-registry-main__stats-progress-item-amount">
                {{ registryProgressStats.error.sum }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </transactions-page-controls>
    <payouts-registry-main-table
      class="payouts-registry-main__table"
      :payouts-registry-items="payoutsRegistryPositions.list || []"
      @repeatPayoutsRegistryItem="repeatPayoutsRegistryItem"
    ></payouts-registry-main-table>
    <success-notification
      ref="payoutsRegistryProcessingNotification"
      :text="
        $t('payouts.by-registry.created.notifications.registry-in-progress')
      "
    ></success-notification>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../../utils/gogocodeTransfer'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import TransactionsPageControls from '@vue-app/components/company/transactions/shared/transactions-page-controls/TransactionsPageControls.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import { Stats } from '@js-app/entities/transaction/Stats'
import TransactionsTable from '@vue-app/components/company/transactions/table/TransactionsTable.vue'
import PayoutsRegistryCreatedTable from '@vue-app/components/company/payouts/by-registry/table/PayoutsRegistryCreatedTable.vue'
import { mapState } from 'vuex'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import PayoutsRegistryItemDeletePopup from '@vue-app/components/company/payouts/by-registry/popup/PayoutsRegistryItemDeletePopup.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import Loader from '@vue-app/components/base/Loader.vue'
import PayoutsRegistryMainTable from '@vue-app/components/company/payouts/by-registry/table/PayoutsRegistryMainTable.vue'
import { formatCoinsToText } from '@js-app/services/helpers/numbers'
import { downloadBase64File } from '@js-app/services/helpers/download'

export default {
  name: 'PayoutsRegistryMain',
  components: {
    PayoutsRegistryMainTable,
    Loader,
    SuccessNotification,
    PayoutsRegistryItemDeletePopup,
    PayoutsRegistryCreatedTable,
    TransactionsTable,
    RequireAccess,
    TransactionsPageControls,
    PrimaryButton,
  },
  props: {
    payoutsRegistry: {
      type: Object,
    },
    payoutsRegistryPositions: {
      type: Object,
    },
  },
  data() {
    return {
      billsRegistryPositionsList: [],
      isRegistryPositionDeleting: false,
      isRegistryProcessing: false,
      isExportRunning: false,
    }
  },
  computed: {
    ...mapState(['selectedCompany']),
    registryStats() {
      return new Stats({
        OperationsStats: {
          All: {
            Sum: this.payoutsRegistryPositions.registry_stat.total_sum,
            Count: this.payoutsRegistryPositions.registry_stat.position_count,
          },
        },
      })
    },
    registryCommission() {
      return formatCoinsToText(
        this.payoutsRegistryPositions.registry_stat.total_commission
      )
    },
    registryProgressStats() {
      return {
        processing: {
          count:
            this.payoutsRegistryPositions.registry_stat.sum_statistics
              .processing_stat.count,
          sum: `${formatCoinsToText(
            this.payoutsRegistryPositions.registry_stat.sum_statistics
              .processing_stat.sum
          )} ₴`,
          percents: (
            (this.payoutsRegistryPositions.registry_stat.sum_statistics
              .processing_stat.count /
              this.registryStats.allStats.count) *
            100
          ).toFixed(0),
        },
        completed: {
          count:
            this.payoutsRegistryPositions.registry_stat.sum_statistics
              .completed_stat.count,
          sum: `${formatCoinsToText(
            this.payoutsRegistryPositions.registry_stat.sum_statistics
              .completed_stat.sum
          )} ₴`,
          percents: (
            (this.payoutsRegistryPositions.registry_stat.sum_statistics
              .completed_stat.count /
              this.registryStats.allStats.count) *
            100
          ).toFixed(0),
        },
        error: {
          count:
            this.payoutsRegistryPositions.registry_stat.sum_statistics
              .error_stat.count,
          sum: `${formatCoinsToText(
            this.payoutsRegistryPositions.registry_stat.sum_statistics
              .error_stat.sum
          )} ₴`,
          percents: (
            (this.payoutsRegistryPositions.registry_stat.sum_statistics
              .error_stat.count /
              this.registryStats.allStats.count) *
            100
          ).toFixed(0),
        },
      }
    },
  },
  created() {
    this.billsRegistryPositionsList =
      this.billsRegistryPositionsList?.bills || []
  },
  methods: {
    async repeatPayoutsRegistryItem(payoutsRegistryItem) {
      if (this.isRegistryProcessing) {
        return
      }

      this.isRegistryProcessing = true

      try {
        await CompaniesApi.repeatPayoutsRegistryItem(
          this.selectedCompany,
          this.payoutsRegistry.id,
          payoutsRegistryItem.id
        )
      } finally {
        this.isRegistryProcessing = false
      }
    },
    async handleExport(exportType) {
      if (this.isExportRunning) {
        return
      }

      this.isExportRunning = true
      try {
        let exportResponse = await CompaniesApi.exportPayoutsRegistry(
          this.selectedCompany,
          this.payoutsRegistry.id
        )

        downloadBase64File(
          exportResponse.data.FileBase64,
          `payouts-registry-${this.payoutsRegistry.id}.${exportType.id}`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
      } catch (e) {
        console.error(e)
      } finally {
        this.isExportRunning = false
      }
    },
    handleRefresh() {
      $emit(this, 'refresh')
    },
  },
  emits: ['refresh'],
}
</script>

<style lang="scss" scoped>
.payouts-registry-main {
  position: relative;
  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  }

  &__table {
    margin-top: 21px;
  }

  &__stats {
    margin-top: 15px;
    padding: 15px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 30px;
    background: #ffffff;
    border-radius: 20px;

    &-details {
      border: 1px solid #eff2f8;
      border-radius: 10px;

      &-item {
        display: grid;
        grid-template-columns: 1fr 1fr;
        border-bottom: 1px solid #eff2f8;

        &:last-child {
          border-bottom: none;
        }

        &-title {
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          color: #67768a;
          padding: 19px 40px 22px 40px;
          border-right: 1px solid #eff2f8;
          display: flex;
          align-items: center;
        }

        &-value {
          padding: 19px 33px 22px 33px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: #585f6d;
        }
      }
    }

    &-progress {
      padding: 20px 40px;

      &-item {
        display: flex;
        align-items: flex-end;
        margin-bottom: 15px;

        &:last-child {
          margin-bottom: 0;
        }

        &--completed & {
          &-title {
            &-text,
            &-value {
              color: #83c382;
            }
          }

          &-row {
            background: #ccf7cb;

            &-filled {
              background: #83c482;
            }
          }
        }

        &--processing & {
          &-title {
            &-text,
            &-value {
              color: #71a2dd;
            }
          }

          &-row {
            background: #dbe7fd;

            &-filled {
              background: #71a2dd;
            }
          }
        }

        &--error & {
          &-title {
            &-text,
            &-value {
              color: #f56767;
            }
          }

          &-row {
            background: #fdd9d9;

            &-filled {
              background: #f56767;
            }
          }
        }

        &-title {
          display: flex;
          align-items: center;
          margin-bottom: 3px;

          &-text {
            font-weight: 500;
            font-size: 12px;
            line-height: 28px;
            margin-right: 19px;
          }

          &-value {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
          }
        }

        &-bar {
          width: 308px;
          margin-right: 25px;
        }

        &-row {
          position: relative;
          border-radius: 15px;
          width: 100%;
          height: 20px;
          overflow: hidden;

          &-filled {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
          }

          &-percents {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            font-weight: 500;
            font-size: 12px;
            line-height: 20px;
            color: #ffffff;

            &.left {
              left: calc(100% + 6px);
            }

            &.right {
              right: 8px;
            }
          }
        }

        &-amount {
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #585f6d;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
